import { CategoriesProvider } from './../../providers/categories/categories';
import { ValueProvider } from './../../providers/value/value';
import { PrivateProfilePage } from './../../pages/me/settings/private-profile/private-profile';
import { DistanceUnit, TrackingService } from '../../providers/tracking.service';
import { Component, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Platform, NavParams, ModalController, ActionSheetController, App, NavController, LoadingController, ToastController } from 'ionic-angular';
import { Subscription, Subject } from 'rxjs';
import { timer } from 'rxjs/observable/timer';
import { LocationProvider } from '../location-handler';
import { EventProvider } from '../../providers/event/event';
import { ResultProvider } from '../../providers/result/result';
import { TrackingSettingsPage } from '../../pages/tracking-settings/tracking-settings';
import { StepDetector } from '../step-detector';
import { DeviceMotion, DeviceMotionAccelerationData } from '@ionic-native/device-motion';
import { GpsTracker } from '../gps-tracker';
import { AudioSystemProvider } from '../../providers/audio-system/audio-system';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { RouteMarathon, StrackerProvider, TrackerModel } from '../../providers/stracker/stracker';
import { SessionProvider } from '../../providers/session/session';
import { Device } from '@ionic-native/device';
import { StepController } from '../step-controller';
import { PermissionPage } from '../sencha-tracker/tutorial-permission/permission';
import { ConfigProvider } from '../../providers/config/config';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { AutoPause, ObserverGeneral, SubjectGeneral } from '../autopause/autopause';
import { ResultDescriptionPage } from '../../pages/results/result-description/result-description';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { IconPipe } from '../../pipes/icon/icon';
import { StrackerUtils } from '../sencha-tracker/stracker-utils';
import { LocationHandlerUtil } from '../location-handler-utils';
import { NewsController } from '../../providers/news/news-contoller';
import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { OneKmStatistics, RunStatistics } from '../run-statistics/run-statistics';
import L from 'leaflet';
import * as LO from 'leaflet.offline';
import { getTileUrls, downloadTile, saveTile } from 'leaflet.offline';
import { NearbyEventParticipantSearchPage } from '../../pages/nearby/nearby-event-participant-search/nearby-event-participant-search';
import { ParticipantsPageMode } from '../../providers/nearby-participants.service';
import { DateFormatModel, SettingsProvider } from '../../providers/settings/settings';
import { AdsProvider } from '../../providers/ads/ads';
import { ThemeMode } from '../../providers/dark-mode/dark-mode';

declare var google;
declare var cordova;

@Component({
    selector: 'track-page-new',
    templateUrl: 'trackpage.new.html',
})
export class TrackPage implements ObserverGeneral {
    @ViewChild('maptracker') mapElement: ElementRef;
    map: any;

    @ViewChild('bib') bibElement: ElementRef;

    locater: LocationProvider;
    clock = null;
    state: boolean = false;
    modal = null;
    activityType: number = -1;
    paused: boolean = false;
    localConfig = null;
    started = false;
    event: any;
    stepDetector: StepDetector = null;
    steps = 0;
    data: TrackerModel = null;
    hasDistance: boolean = false;

    events: any = [];
    eventNames: any = [];
    activeEvent: any;

    stepController: StepController = new StepController();
    onLocationSub: Subject<boolean> = new Subject();

    controllerScope: boolean;
    reachedSub: Subject<boolean> = new Subject();
    reachedStartingPointSub: Subject<boolean> = new Subject();
    stepIncreaseSub: Subject<any> = new Subject();

    raceFinished: boolean = false;
    actionPresented: boolean = false;
    viewClose: Promise<any> = null;

    lastSumDistanceForBG: number = 0;
    lastSteps: number = 0;

    viewResolver = null;

    imageLink = null;
    isMap: boolean = false;
    dataSent = false;
    iconTitle: string = "assets/imgs/sportart_svg/laufen.svg";

    view = {
        average_pace: "0",
        average_speed: "0.0"
    }

    updateViewSub: Subscription = null;
    token: string = "";
    appName: string = "";

    testMode: boolean = false;

    // UI elements
    showheader: boolean = true;
    hideheader: boolean = false;
    settingsButton: boolean = false;
    isStopPressed: boolean = false;
    isPlayDisabled: boolean = false;
    stopAllowed: boolean = false;
    warningMessage: boolean = false;

    color: string = "black";
    colorIcon: string = "black";
    bgColor: string = "white";
    types: any;

    mode: any = {
        id: 16,
        name: "Laufen",
        uniqueName: "RunEnduranceTraining"
    };
    isPremium: boolean = false;
    allowCountdown: boolean = true;

    route: RouteMarathon = {
        hasRoute: false,
        fullPath: []
    };

    runStatistics: RunStatistics;
    isMapPreloaded: boolean = true;
    baseLayer;
    urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    finishMarker;
    startMarker;

    followerSub: Subscription = null;
    canLeave: boolean = true;
    activeItem: any = {
        participants: [],
        markers: []
    };

    activeDateFormat: string;

    constructor(
        public platform: Platform,
        private navParams: NavParams,
        private resultService: ResultProvider,
        private modalCtrl: ModalController,
        private deviceMotion: DeviceMotion,
        private audioService: AudioSystemProvider,
        private actionSheetCtrl: ActionSheetController,
        private translate: TranslateService,
        private app: App,
        private loadingCtrl: LoadingController,
        private storage: Storage,
        private strackerService: StrackerProvider,
        private sessionService: SessionProvider,
        private device: Device,
        private config: ConfigProvider,
        private storageService: StorageProvider,
        private zone: NgZone,
        private toastCtrl: ToastController,
        private valueService: ValueProvider,
        private categoryService: CategoriesProvider,
        private appDetector: AppDetectorProvider,
        private icons: IconPipe,
        private eventService: EventProvider,
        private trackingService: TrackingService,
        private settingsService: SettingsProvider,
        private navCtrl: NavController,
        private ads:AdsProvider) {
            let themeMode= JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
            if(themeMode =='darkMode') this.iconTitle='assets/imgs/sportart_svg/laufen-white.svg'
        }

    getParticipantsLocations(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!this.event.eventId && !this.event.id) { reject("[ERROR] no event id or eventId found"); return; }
            this.eventService.getNearbyParticipantPosititons(this.activeItem.participants.map(p => p.lid), this.event.eventId || this.event.id).then(participantsLocations => {
                // console.log('got participants locations', JSON.stringify(participantsLocations))
                resolve(participantsLocations);
            }).catch(err => {
                console.error('error while fetching the participants locations ' + err);
                reject(err);
            });
        });
    }

    displayParticipants(locations): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.participants.length; i++) {
                let locIndex = locations.findIndex(loc => loc.lid == this.activeItem.participants[i].lid);
                if (locIndex < 0) continue;
                let index = this.activeItem.markers.findIndex(m => {m.lid == this.activeItem.participants[i].lid});
                if (index < 0) {
                    // create
                    let marker = new L.Marker([0, 0]);
                    let icon = L.icon({
                        iconUrl: this.activeItem.participants[i].img,
                        iconSize: [35, 35]
                    });
                    try{
                        marker.setIcon(icon);
                    }catch(err){
                        console.log('error in display marker', JSON.stringify(err))
                    }
                    try{
                        marker.addTo(this.map);
                    }catch(err){
                        console.log('error in add marker', JSON.stringify(err))
                    }
                    try{
                        marker.setLatLng(L.latLng(locations[locIndex].lat, locations[locIndex].lng));
                    }catch(err){
                        console.log('error in setlatlng', JSON.stringify(locations[index]), index)
                    }
                    try{
                        this.activeItem.markers.push({ marker: marker, lid: this.activeItem.participants[i].lid });
                    }
                    catch(err){
                        console.log('push err', JSON.stringify(err))
                    }
                } else {
                    // update
                    try{
                        this.activeItem.markers[index].marker.setLatLng(L.latLng(locations[locIndex].lat, locations[locIndex].lng));
                    }
                    catch(err){
                        console.log('error in setlatlng else', JSON.stringify(err)) 
                    }
                    this.activeItem.markers[index].marker.update();
                }
            }
            resolve(this.activeItem.markers);
        });
    }

    updateParticipantsMarkers(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.markers.length; i++) {
                let indexOf = this.activeItem.participants.length ? this.activeItem.participants.findIndex(f => f.lid == this.activeItem.markers[i].lid) : -1;
                if (indexOf <= 0) {
                    const element = this.activeItem.markers[i].marker;
                    setTimeout(()=>{
                        try{
                            this.map.removeLayer(element);
                        }catch (err){
                            console.log('error in remove marker', JSON.stringify(err))
                        }
                    },1500)
                    if (this.activeItem.participants[i]){
                        this.activeItem.markers = this.activeItem.markers.filter(m => m.lid != this.activeItem.participants[i].lid);
                        console.log('this.activeItem.markers', JSON.stringify(this.activeItem.markers))
                    }
                }
            }
        });
    }

    clearParticipantsMarkers(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            for (let i = 0; i < this.activeItem.markers.length; i++) {
                // let locIndex = this.activeItem.participants.findIndex(p => p.lidOrRaceResultId == this.activeItem.markers[i].lid);
                // if (locIndex < 0) {
                const element = this.activeItem.markers[i];
                this.map.removeLayer(element);
                delete this.activeItem.markers[i];
                // }
            }
            this.activeItem.markers = [];
            resolve([]);
        });
    }

    openAddParticipansPage() {
        this.canLeave = false;
        if (this.sessionService.checkUserProfile()) {
            this.navCtrl.push(NearbyEventParticipantSearchPage, { activeItem: this.activeItem, mode: ParticipantsPageMode.LOCATION_EXPORT, locater: this.getLocater() });
        } else {
            let loader = this.loadingCtrl.create({
                content: this.translate.instant('GLOBAL_LOADING')
            });
            loader.present();

            Promise.all([
                this.valueService.getProfileTitles(),
                this.valueService.getProfileTypes(),
                this.valueService.getCountries(),
                this.categoryService.getProfileCategoires(),
                this.valueService.getProfileBackgrounds()
            ]).then(values => {
                this.navCtrl.push(PrivateProfilePage, {
                    data: {
                        titles: values[0],
                        types: values[1],
                        countries: values[2],
                        categories: [],
                        photos: [],
                        backgrounds: values[4],
                        profile: this.sessionService.profile
                    }
                }).then(() => loader.dismiss());
            });
        }
    }

    initialize() {
        this.event = {
            eventId: -1,
            eventName: "aufzeichnen-run"
        };

        // Global variable, used to check if the news can be updated
        GpsTracker.isRunning = true;

        // Thurnau app has the endless distance
        this.hasDistance = false;
        this.stopAllowed = true;
        this.resultService.getEndurances().then(async result => {
            this.types = result;
            await this.strackerService.getSaved("track-mode").then((mode) => {
                if (mode) this.mode = mode;
            })
            let type = this.types.find(e => e.name === this.mode.name);
            this.runStatistics.writeEventCid(type.id);
            this.event.cid = type.id;
        });
    }
    ionViewDidEnter() {
        this.isPremium = Boolean(JSON.parse(localStorage.getItem('premium'))) || false;
        if (!this.sessionService.isLoged) return;

        setTimeout(() => this.trackingService.reconfigurePlugin(), 1000);

        this.route = this.navParams.get("route");
        this.imageLink = this.navParams.get("imageLink");
        this.isPremium = JSON.parse(localStorage.getItem('premium')) || false;
        this.viewClose = new Promise<any>((resolve, reject) => {
            this.viewResolver = resolve;
        });
        this.settingsService.getActiveLanguage().then((lang) => {
            this.settingsService.getActiveDateFormat().then((format: DateFormatModel) => {
                if (format) {
                    this.activeDateFormat = format.key;
                } else {
                    this.activeDateFormat = lang.includes("de") ? "dd.MM.yyyy" : "MM/dd/yyyy";
                }
            });
        });
        this.preloadUI();

        this.initialize();
        let needLocation = this.appDetector.isHannoverApp() || this.appDetector.isForestApp();

        this.locater = new LocationProvider(
            this.map,
            this.reachedSub,
            this.event,
            this.zone,
            this.toastCtrl,
            this.platform,
            this.reachedStartingPointSub,
            this.storageService,
            this.appDetector,
            this.trackingService.options.google,
            needLocation ? this.onLocationSub : null
        );
        this.runStatistics = new RunStatistics({ localDb: this.storageService, locater: this.locater, event: this.eventService }, this.event);

        if (this.sessionService.isLoged) {
            const userId = this.sessionService.profile.id;

            this.runStatistics.writeUserId(userId);
            this.activeItem.id = typeof this.event === "undefined" ? -1 : this.event.eventId;
            this.strackerService.getResultPreload((typeof this.event === "undefined") ? -1 : this.event.eventId, userId + "").then((data: TrackerModel) => {
                this.data = data;
                this.runStatistics.load();
                this.initPreload();
            });
        }

        AutoPause.getInstance().attach(this);

        this.preloadSettings();

        if (!this.updateViewSub) {
            this.updateViewSub = timer(0, 5000).subscribe(() => {
                if ((this.appDetector.isHellaApp() || this.appDetector.isForestApp() || this.appDetector.isThurnauApp()) && this.started)
                    this.runStatistics.writeRoutePoints();

                this.getCurrentSpeed();
                this.getAverageSpeed();
            });
        }
        if (this.appDetector.isHannoverApp() || this.appDetector.isForestApp()) {
            this.onLocationSub.subscribe((location: any) => {
                let coords = { lat: location.coords.latitude, lng: location.coords.longitude };
                this.path.push(coords);
                this.saveTiles();
            });
        }
        if (!this.followerSub) {
            this.followerSub = timer(0, 2000).subscribe(() => {
                this.getParticipantsLocations().then(participantsLocations => {
                    this.displayParticipants(participantsLocations).then(() => {
                        this.updateParticipantsMarkers().then(() => {
                        });
                    });
                });
            });
        }
        if (this.sessionService.isLoged) {
            this.firstStart();
            this.trackingService.options.google ? this.loadGoogleMaps() : this.loadLeafletMaps();
            this.getEvents();
        }
    }

    loadLeafletMaps() {
        setTimeout(() => {
            this.map = (L as any).map('maptracker', {
                trackResize: false
            });

            this.baseLayer = (L as any).tileLayer
                .offline(this.urlTemplate, {
                    attribution: 'Map data {attribution.OpenStreetMap}',
                    subdomains: 'abc',
                    minZoom: 16
                })
                .addTo(this.map);

            this.map.setView(
                {
                    lat: 52.5204345,
                    lng: 13.4014027,
                },
                16
            );

            // add buttons to save tiles in area viewed
            const control = (L as any).control.savetiles(this.baseLayer, {
                zoomlevels: [16, 16], // optional zoomlevels to save, default current zoomlevel
                confirm(layer, successCallback) {
                    // eslint-disable-next-line no-alert
                    // if (window.confirm(`Save ${layer._tilesforSave.length}`)) {
                    successCallback();
                    // }
                },
                confirmRemoval(layer, successCallback) {
                    // eslint-disable-next-line no-alert
                    if (window.confirm('Remove all the tiles?')) {
                        successCallback();
                    }
                },
                saveText:
                    '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
                rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
            });
            control.addTo(this.map);

            let progress;
            this.baseLayer.on('savestart', (e) => {
                progress = 0;
            });
            this.baseLayer.on('savetileend', () => {
                progress += 1;
            });

            this.getLocater().setMap(this.map);

        }, 400);
    }

    async drawRoute() {
        this.getLocater().getMapHandler().newPoly();
        this.getLocater().getMapHandler().setPolyDestinations(this.route.fullPath);
        this.getLocater().getMapHandler().drawPolyLines(true);
        this.getLocater().getMapHandler().setMapCenterLatLng(this.route.fullPath[0]);

        let startMarker = new google.maps.Marker({
            position: this.route.fullPath[0],
            map: this.getLocater().getMapHandler().getMap(),
            icon: await this.icons.transform(this.event.cid + '', 'marker')
        });

        let finishMarker = new google.maps.Marker({
            position: this.route.fullPath[this.route.fullPath.length - 1],
            map: this.getLocater().getMapHandler().getMap(),
            icon: this.icons.get('marker', 'finish')
        });
    }

    update(subject: SubjectGeneral): void {
        if (subject instanceof AutoPause) {
            this.stopTrack(false, false, false);
        }
    }

    preloadSettings() {
        if (!this.event) return;

        this.storageService.checkForExistance('stop-button-' + this.event.id + "-" + this.token).then((status) => {
            if (status) this.strackerService.getSaved('stop-button-' + this.event.id + "-" + this.token).then((data) => this.isStopPressed = data);
        });
    }

    changeMode() {
        const name = this.mode.name.split(' ').join('');
        this.iconTitle = "assets/imgs/sportart_svg/" + this.converted(name.toLocaleLowerCase()) + ".svg";
        let type = this.types.find(e => e.name === this.mode.name);
        this.mode = type;
        this.strackerService.saveData(this.mode, "track-mode");
        this.event.cid = type.id;
    }

    converted(mode: string) {
        let result = mode;
        if (mode.includes("inline")) {
            result = "inlineskating";
        } else if (mode.includes("indoor")) {
            result = "indoorbicycle";
        }
        return result;
    }

    changeModeEvent() {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        NewsController.getInstance().isAllowed = false;
        let event = this.events.find((e) => e.name === this.activeEvent);
        this.eventService.getEventDetails(event.id).then((event) => {

            if (event.name.length < 1) {
                this.changeModeEvent();
                loader.dismiss();
            } else {
                (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
            }
        }).catch(err => loader.dismiss());

    }

    locationPermission(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(null);
        });
    }

    permissionRequest(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.storage.keys().then((data) => {
                let table = data.includes("ios-perm-check-" + this.appName);
                if (table) {
                    resolve(true);
                } else {
                    resolve(false);
                }

            })
        });
    }

    permissionWrite(): Promise<any> {
        return this.strackerService.saveData(true, ("ios-perm-check-" + this.appName));
    }

    goToResultStatisticsPage() {
        this.sendData();
    }

    initPreload() {
        if (this.data) {
            GpsTracker.sumDistance = this.data.distance;
            this.getLocater().setCurrentDuration(this.data.time);
            GpsTracker.currentSpeed = LocationHandlerUtil.calcPace(GpsTracker.sumDistance, this.getLocater().getCurrentDuration());
            this.view.average_pace = this.data.average_pace;
            this.view.average_speed = this.data.average_speed + "";
            this.raceFinished = this.data.finished;
        }
    }

    triggerPauseResume() {
        this.platform.ready().then(() => {

            if (this.platform.is('cordova')) {

                //Subscribe on pause i.e. background
                this.platform.pause.subscribe(() => {
                    GpsTracker.isBackground = true;
                    this.lastSumDistanceForBG = GpsTracker.sumDistance;
                    this.lastSteps = this.stepDetector.stepCount;
                    this.saveData(false);
                });

                //Subscribe on resume i.e. foreground 
                this.platform.resume.subscribe(() => {
                    GpsTracker.isBackground = false;
                    this.locater.setCurrentTime();
                    this.calculateBgSteps();
                    this.invokeMenu();
                });
            }
        });
    }

    ionViewWillLeave() {
        if (!this.sessionService.isLoged || !this.canLeave) return;
        this.stopTrack(false);
        this.saveData(false);

        if (this.stepCountSub) {
            this.stepCountSub.unsubscribe();
            this.stepCountSub = null;
        }

        if (this.onLocationSub) {
            this.onLocationSub.unsubscribe();
            this.onLocationSub = null;
        }

        if (this.followerSub) {
            this.followerSub.unsubscribe();
            this.followerSub = null;
        }

        if (this.updateViewSub) {
            this.updateViewSub.unsubscribe();
            this.updateViewSub = null;
        }
        this.getLocater().terminate(true);
        this.getLocater().clear();
        // this.getLocater().getMapHandler().clearMeMarker();
        this.getLocater().DISTANCE_TO_WIN = null;
        GpsTracker.isRunning = false;
        this.getLocater().pluginTerminate();
        this.getLocater().getMapHandler().destroy();

        GpsTracker.isRunning = false;
    }

    saveData(finished) {
        if (finished) {
            this.strackerService.writeDataFinished(this.prepareSaveData()).then(() => {
            });

            this.storageService.saveData(this.mode, 'track-mode').then(() => {
            });
        } else {
            this.strackerService.pushDataNotFinished(this.prepareSaveData()).then(() => {
            });
        }
    }

    prepareSaveData() {
        let obj: TrackerModel = {
            eventId: (this.event) ? this.event.eventId : -1,
            token: this.token + "",
            time: this.getLocater().getCurrentDuration(),
            distance: GpsTracker.sumDistance,
            finished: this.raceFinished,
            average_pace: this.getCurrentSpeed(),
            average_speed: this.getAverageSpeed()
        }
        return obj;
    }

    getMapPath() {
        return this.getLocater().getMapPath();
    }

    invokeMenu() {
        if (this.raceFinished && !this.actionPresented && (GpsTracker.sumDistance >= this.getLocater().DISTANCE_TO_WIN)) {
            this.viewResolver();
            this.raceFinished = true;

            this.actionPresented = true;

            this.saveData(true);

            this.strackerService.remove();

            this.sendData();
        }
    }

    presentActionSheet() {
        const actionSheet = this.actionSheetCtrl.create({
            title: this.translate.instant('RACE_FINISHED'),
            buttons: [
                {
                    text: 'OK',
                    role: 'destructive',
                    handler: () => {
                        this.openResults();
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                }
            ]
        });
        actionSheet.present();
        this.actionPresented = true;
    }

    onTest() {
        this.warningMessage = false;
    }

    async openResults(timeout?: number) {
        this.canLeave = false;
        this.navCtrl.push(ResultDescriptionPage, { statisticsResults: this.runStatistics.getWrappedStatistics(), registration: this.imageLink });
    }

    calculateBgSteps() {
        if (this.lastSteps != 0) {

            let average = Math.round(this.lastSumDistanceForBG / this.lastSteps);
            let diff = Math.round(GpsTracker.sumDistance - this.lastSumDistanceForBG);

            this.stepDetector.stepCount += (diff * average);
        }
    }

    getEvents() {
        this.eventService.getClientEvents().then((events) => {
            this.events = Object.assign([], events);
            this.eventNames = [...new Set(this.events.map((e) => e.name))];
            this.activeEvent = this.eventNames[0];
        });
    }

    async preloadUI() {
        this.color = (await this.config.config).theme.color;
        this.colorIcon = (await this.config.config).theme.color;
        this.appName = (await this.config.config).appId;

        if (this.appDetector.isHellaApp()) {
            this.color = this.colorIcon = "white";
            this.bgColor = "#002f5d";
        } else if (this.appDetector.isEventsApp()) {
            this.color = this.colorIcon = "black";
            this.bgColor = "white";
        } else if (this.appDetector.isThurnauApp()) {
            this.color = "black";
        }
    }

    async getPermission() {
        if (this.platform.is('ios')) {
            this.permissionRequest().then((check) => {
                if (!check || this.getLocater().authStatus !== 1) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("ios");
                    });
                }
            });
        } else if (this.platform.is('android') && (this.device.version.includes("11"))) {
            this.permissionRequest().then((check) => {
                if (!check) {
                    this.permissionWrite().then(() => {
                        this.goPermissionPage("android");
                    });
                }
            });
        }
    }

    goPermissionPage(OS: string) {
        (this.app.getRootNav() as NavController).push(PermissionPage, { os: OS });
    }

    saveStatistics() {
        this.runStatistics.add().then(() => {
            this.runStatistics.save();
        });
    }

    firstStart() {
        this.platform.ready().then(() => {

            this.initSubscription();

            this.getLocater().placementEnabled = this.trackingService.options.placement;

            this.stepDetector = new StepDetector(this.stepIncreaseSub);

            this.initPreload();

            this.triggerPauseResume();

            this.stepIncreaseSub.subscribe(() => {
                this.getLocater().setLastStep(new Date().getTime());
            });
        });

    }

    initSubscription() {
        try {
            this.reachedSub.subscribe((final) => {
                if (!this.raceFinished)
                    if (this.appDetector.isHellaApp() || this.appDetector.isForestApp()) {
                        this.saveStatistics();
                    }
                if (!this.raceFinished)
                    if (final) {
                        this.raceFinished = true;
                        this.distanceReached();
                    } else if (!final) {
                        this.audioService.playAudio(GpsTracker.isBackground, false, this.trackingService.options.applause);
                            console.log('GpsTracker.isBackground', GpsTracker.isBackground)
                    }
            });

            this.reachedStartingPointSub.subscribe((status) => {
                if (!this.raceFinished)
                    if (status && this.route.hasRoute) {
                        this.isPlayDisabled = false;
                        this.warningMessage = false;
                    }
            });

        } catch (err) {
            console.log("error while init subscription " + err);
        }

    }

    path = [];
    saveTiles() {
        let points = this.path.map(coords => L.point(coords.lat, coords.lng));
        let bounds = L.bounds(points);
        let urls = getTileUrls(this.baseLayer, bounds, 16);
        for (let i = 0; i < urls.length; i++) {
            downloadTile(urls[i].url).then(blob => {
                saveTile(urls[i], blob).then(() => {
                });
            });
        }
    }


    onBackMenu() {
    }

    distanceReached() {
        this.audioService.playAudio(GpsTracker.isBackground, true, this.trackingService.options.applause);
        this.stop(false);
        if (!GpsTracker.isBackground) {
            this.invokeMenu();
        }
        this.strackerService.remove();
    }

    sendData(distance = null) {
        this.prepareRunStatisticsData().then((runStatistics) => {
            if (navigator.onLine) {
                let d = (distance) ? parseInt(distance) : null;
                this.resultService.sendVirtualResults(runStatistics, d).then(() => {
                    this.storage.remove('resultVirtual');
                    this.openResults();
                }).catch((err) => console.log('error while sending data ' + err));
            } else {
                this.noConnectionSave(runStatistics);
                this.openResults();
            }
        });
    }

    noConnectionSave(obj) {
        let loading = this.loadingCtrl.create({
            content: this.translate.instant('NO_CONNECTION_SAVE'),
            duration: 10000
        });
        loading.present();

        window.addEventListener('online', () => {
            if (!this.dataSent) {
                this.resultService.sendVirtualResults(obj).then(() => {
                    this.dataSent = true;
                    this.storage.remove('resultVirtual').then(() => {
                        loading.dismiss();
                        // this.openResults(10000);
                    });
                });
            }
        });
    }

    onConfigureModal() {
        const modal = this.modalCtrl.create(TrackingSettingsPage);
        if (this.token.length > 0) localStorage.setItem('token', this.token);
        localStorage.setItem('eventId', this.event.id + "");
        modal.onDidDismiss((response) => {
            this.trackingService.updateTrackingSettings();
            if (this.trackingService.options.autoPause) AutoPause.getInstance().run();
            this.trackingService.options.placement ? this.getLocater().setPlacement(true) : this.getLocater().removePlacement();
            if (response.markerChanged) this.getLocater().refreshMarker();
        });

        modal.present();
    }

    restartTrack() {
        this.sessionService.getToken(false, false).then((token) => {
            if (token.length > 0) localStorage.setItem('token', token);
            // this.token = this.sessionService.profile.id + "";
            this.token = token;

            const actionSheet = this.actionSheetCtrl.create({
                title: this.translate.instant('RESTART_ROUND'),
                buttons: [
                    {
                        text: this.translate.instant('GLOBAL_YES'),
                        role: 'destructive',
                        handler: () => {
                            if (this.getLocater().getCurrentDuration() == 0 && GpsTracker.sumDistance == 0) {
                                return;
                            }
                            this.strackerService.remove();
                            this.getLocater().clear();
                            this.clear();
                            this.stopTrack(false, true);
                            this.enableStopButton();

                            this.getLocater().setSubscriptions(this.reachedSub, this.reachedStartingPointSub);

                            this.actionPresented = false;
                            this.raceFinished = false;
                            GpsTracker.sumDistance = 0;

                            /*
                            UI function,
                            when the user clicks pause we hide the toolbar
                            if the auto pause is triggered we don't hide one
                            */
                            this.showheader = true;
                            this.hideheader = false;

                            if (typeof this.route != "undefined") {
                                if (this.route.hasRoute) {
                                    this.isPlayDisabled = true;
                                    this.warningMessage = true;
                                }
                            }

                            this.stepController.clear();
                        }
                    },
                    {
                        text: this.translate.instant('GLOBAL_NO'),
                        role: 'cancel',
                        handler: () => {
                            console.log('Cancel clicked');
                        }
                    }
                ]
            });
            actionSheet.present();
        });
    }

    clear() {
        this.view.average_speed = "0.0";
        this.view.average_pace = "0";

        this.runStatistics.reset();
        this.runStatistics.delete();

        this.allowCountdown = true;

        if (this.data) {
            this.data.average_pace = "0";
            this.data.average_speed = "0.0";
            this.data.distance = 0;
            this.data.finished = false;
            this.data.time = 0;
        }
    }

    getStarted() {
        return this.started;
    }

    prepareRunStatisticsData() {
        return new Promise<any>((resolve, reject) => {
            console.log(this.runStatistics.routePoints);
            const encodedPath = this.trackingService.encodeRoute(this.runStatistics.routePoints);
            let routeStrn = {
                routeInfos: [{
                    path: encodedPath
                }]
            }
            const totalAltitude = Math.floor(LocationHandlerUtil.calcAltitude(this.runStatistics.kmStatistics.map((r) => r.elevation)));
            // let encodedStatistics = encodeURI(JSON.stringify(this.runStatistics.kmStatistics))
            const dateTimeFormatted = GpsTracker.formatTime(new Date().getTime(), this.settingsService.activeDateFormat, this.translate.getDefaultLang());
            console.log("Date Time Formatted: ");
            console.log(dateTimeFormatted);
            console.log("City: ")
            console.log(this.locater.city);
            console.log("CC: ")
            console.log(this.locater.country_code);
            let object = {
                cid: this.mode.id,
                eventId: this.event.id,
                timeSec: this.getDeepDuration(),
                routeStrn: JSON.stringify(routeStrn),
                detailSplitStrn: this.convertDetailSplitStrn(this.runStatistics.kmStatistics),
                heightInMeterTotal: totalAltitude,
                city: this.locater.city,
                unit: this.trackingService.options.distanceUnit == DistanceUnit.KM ? 'km' : 'mi',
                cc: this.locater.country_code.toLocaleUpperCase,
                lang: this.translate.getDefaultLang(),
                dateTimeFormatted: dateTimeFormatted
            }
            let data = JSON.stringify(object);
            this.storage.set('resultVirtual', data).then(() => {
                resolve(object);
            });
        });
    }

    convertDetailSplitStrn(kmStatistics: OneKmStatistics[]) {
        const detailtSplitStrn = kmStatistics.map(oneKm => {
            return `${oneKm.km},${oneKm.gain},${oneKm.loss},${oneKm.time}`
        }).reduce((acc, cur) => acc + ":" + cur, "");
        return detailtSplitStrn;
    }

    private time2sec(time: string) {

    }

    offlineMap: boolean = false;
    loadGoogleMaps() {
        try {
            this.platform.ready().then(() => {
                var that = this;
                let loadMaps = setInterval(() => {
                    if (typeof google !== "undefined" && window.navigator.onLine) {

                        let mapConfig = {
                            zoom: 15,
                            center: { lat: 52.5204345, lng: 13.4014027 },
                            mapTypeId: google.maps.MapTypeId.TERRAIN,
                            disableDefaultUI: true
                        };

                        that.locater.setMap(new google.maps.Map(that.mapElement.nativeElement, mapConfig));

                        if (typeof this.route !== "undefined") {
                            if (this.route.hasRoute) {
                                this.drawRoute();
                                this.isPlayDisabled = true;
                                this.warningMessage = true;
                                this.getLocater().hasRoute = true;
                                this.getLocater().startingPoint = this.route.fullPath[0];
                                this.getLocater().finishPoint = this.route.fullPath[this.route.fullPath.length - 1];
                            }
                        } else {
                            that.isPlayDisabled = false;
                        }

                        clearInterval(loadMaps);
                    }
                }, 400);
            });
        } catch (err) {
            console.log('loadMaps error = ' + err);
        }
    }

    stepCountSub: any;

    startTrack() {
        let elements = document.getElementsByClassName('tabbar');
        for(let i = 0; i < elements.length; i++){
            // @ts-ignore
            elements[i].style.display = 'none';
        }

        this.sessionService.getToken(false, false).then((token) => {
            if (token.length) localStorage.setItem('token', token);
            this.runStatistics.writeUserId(this.sessionService.profile.id);
            this.token = token;

            if (!this.started || !this.getLocater().stopWatch) {
                this.startConfigs();
            }
        });
    }

    startConfigs() {
        try {
            this.started = true;
            this.showheader = false;
            this.hideheader = true;
            this.getLocater().startTrack((this.data) ? this.data.time : 0);
            if (!this.stepCountSub) this.runAccel();
            this.initPreload();
            this.adjustMapCenter();
        } catch (err) {
            console.log('start track error = ' + err);
        }

        AutoPause.getInstance().setEnabled(this.trackingService.options.autoPause);

        if (this.trackingService.options.autoPause) AutoPause.getInstance().run();
    }

    adjustMapCenter() {
        setTimeout(() => {
            let height = document.getElementById("maptracker").clientHeight;
            let initialCenter = JSON.parse(localStorage.getItem('lastPos'));
            if (initialCenter) {
                let coords = new L.LatLng(initialCenter.coords.latitude, initialCenter.coords.longitude);
                this.getLocater().getMap().setView(coords, 16, {
                    animate: true,
                    duration: 0.5,
                    paddingBottomRight: [0, height / 2],
                });
                this.getLocater().getMap().invalidateSize();
            }
        }, 700);
    }

    runAccel() {
        this.stepDetector.clear();

        try {
            this.stepCountSub = this.deviceMotion.watchAcceleration({ frequency: 100 }).subscribe((acceleration: DeviceMotionAccelerationData) => {
                let step = this.stepDetector.isAStep(acceleration.x, acceleration.y, acceleration.z);
                this.steps = this.stepDetector.stepCount;


                if (step) {
                    AutoPause.getInstance().setLastAction(new Date());
                    if (!AutoPause.getInstance().isRunning() && !this.started) {
                        this.startTrack();
                    }
                }
            });
        } catch (err) {
            console.log("Accel. Error = " + err);
        }
    }

    stopTrack(pause: boolean, restart: boolean = false, showDisplay: boolean = true) {
        AutoPause.getInstance().setRunning(false);
        console.log("pause: " + pause);
        // @ts-ignore
        if (showDisplay){
            let elements = document.getElementsByClassName('tabbar');
            for (let i = 0; i < elements.length; i++) {
                // @ts-ignore
                elements[i].style.display = 'flex';
            }
        } 
        if (this.started || this.getLocater().stopWatch) {
            this.data = null;
            this.getLocater().stopTrack();
            this.started = false;
            if (!restart) {
                this.runStatistics.updateMainRunStatistics().then(() => {
                    this.runStatistics.save();
                })
            }
        }
        this.adjustMapCenter();
        if (pause) {
            if (this.stepCountSub) {
                this.stepCountSub.unsubscribe();
                this.stepCountSub = null;
            }
            this.getLocater().pluginTerminate();
        }
    }

    stop(pause: boolean) {
        this.showheader = true;
        this.hideheader = false;

        this.stopTrack(pause);
    }

    fullStop(pause: boolean) {
        console.log("pause: " + pause);
        // if (this.started) {
        this.stop(pause);
        const actionSheet = this.actionSheetCtrl.create({
            title: this.translate.instant('FULL_STOP_MESSAGE'),
            buttons: [
                {
                    text: this.translate.instant('GLOBAL_YES'),
                    role: 'destructive',
                    handler: () => {
                        this.raceFinished = true;
                        this.saveData(true);
                        this.strackerService.remove();
                        this.getLocater().raceFinished = true;
                        this.sendData(GpsTracker.sumDistance);
                        this.disableStopButton();
                    }
                },
                {
                    text: this.translate.instant('GLOBAL_NO'),
                    role: 'cancel',
                    handler: () => {
                        this.startTrack();
                    }
                }
            ]
        });
        actionSheet.present();
        // }
    }

    disableStopButton() {
        this.strackerService.saveData(true, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = true;
        });
    }

    enableStopButton() {
        this.strackerService.saveData(false, ("stop-button-" + this.event.id + "-" + this.token)).then(() => {
            this.isStopPressed = false;
        });
    }

    isStopDisabled() {
        return (GpsTracker.sumDistance > 0) ? false : true;
    }

    getCurrentSpeed() {
        if (this.sessionService.isLoged) {
            let num = (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentSpeed() : "0";
            this.view.average_pace = num;
            return this.view.average_pace;
        } else {
            return "0:00";
        }
    }

    getDeepDuration() {
        return (typeof this.getLocater() !== "undefined") ? this.getLocater().getCurrentDuration() : 0;
    }

    getAveragePace(pace) {
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            return (Number(pace) * 1.60934).toFixed(1);
        }
        return pace;
    }

    getAvSpeed(speed) {
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            return (Number(speed) * 0.621371).toFixed(1);
        }
        return speed;
    }


    getCurrentDuration() {
        return StrackerUtils.transormSeconds(this.getDeepDuration());
    }

    getAverageSpeed() {
        if (this.sessionService.isLoged) {
            let sec = this.getDeepDuration();
            let dist = Number(this.getDeepDistance()); // already in km
            if (sec == 0) {
                return 0;
            }
            let result = dist / (sec / 3600);
            this.view.average_speed = isNaN(result) ? "0.0" : result.toFixed(1);
            return this.view.average_speed;
        } else {
            return "0.0";
        }
    }

    getDeepDistance() {
        let d = (typeof this.locater !== "undefined") ? this.locater.getSumDistance() : 0;
        if (this.trackingService.options.distanceUnit == DistanceUnit.MILES) {
            d = d * 0.621371;
        }
        return (d / 1000).toFixed(2);
    }

    getLocater() {
        return this.locater;
    }

    public get distanceUnit(): typeof DistanceUnit {
        return DistanceUnit;
    }
}

export interface ParticipantDisplay {
    marker: any;
    lid: any;
}




// WEBPACK FOOTER //
// /src/tracker/track-page/trackpage.ts